'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var styles = require('@material-ui/core/styles');
var ArrowDownwardIcon = _interopDefault(require('@material-ui/icons/ArrowDownward'));
var ArrowUpwardIcon = _interopDefault(require('@material-ui/icons/ArrowUpward'));

var useStyles = styles.makeStyles({
    typeogrophy: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
});
var DownArrow = styled__default(ArrowDownwardIcon)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  height: 14px;\n  vertical-align: top;\n  padding-top: 0px;\n"], ["\n  height: 14px;\n  vertical-align: top;\n  padding-top: 0px;\n"])));
var UpArrow = styled__default(ArrowUpwardIcon)(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  height: 14px;\n  vertical-align: top;\n  padding-top: 0px;\n  &.hidden {\n    visibility: hidden;\n  }\n"], ["\n  height: 14px;\n  vertical-align: top;\n  padding-top: 0px;\n  &.hidden {\n    visibility: hidden;\n  }\n"])));
var SortContainer = styled__default.div(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  &:hover {\n    .MuiTypography-root {\n      color: #12253f;\n    }\n    svg {\n      visibility: visible;\n      fill: #12253f;\n    }\n  }\n"], ["\n  &:hover {\n    .MuiTypography-root {\n      color: #12253f;\n    }\n    svg {\n      visibility: visible;\n      fill: #12253f;\n    }\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3;

exports.DownArrow = DownArrow;
exports.SortContainer = SortContainer;
exports.UpArrow = UpArrow;
exports.useStyles = useStyles;
